module.exports = __webpack_public_path__ + "h5/img/7.b3d99513.jpg";